import { NgModule } from '@angular/core';
import { UtilitiesModule } from '../utilities/utilities.module';
import { SharedModule } from '../@shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedExceptMainModule } from '../@shared-except-main/shared-except-main.module';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TrandingOfferComponent } from './tranding-offer.component';
import { TrandingOfferRoutingModule } from './tranding-offer.routing.module';

@NgModule({
    declarations: [TrandingOfferComponent],
    imports: [
        UtilitiesModule,
        SharedModule,
        FlexLayoutModule,
        SharedExceptMainModule,
        CommonModule,
        MatButtonModule,
        TrandingOfferRoutingModule,
    ],
    exports: [],
})
export class TrandingOfferModule {
    constructor() {}
}
